{
  "app": {
    "name": "Hey Life",
    "tagline": "Deine Woche mit Gott, ein kleiner Schritt nach dem anderen."
  },
  "tabs": {
    "home": "Home",
    "grow": "Grow",
    "challenges": "Challenges",
    "community": "Community",
    "me": "Ich"
  },
  "common": {
    "continue": "Weiter",
    "next": "Weiter",
    "back": "Zurück",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "send": "Senden",
    "share": "Teilen",
    "done": "Fertig",
    "close": "Schließen",
    "later": "Später",
    "yes": "Ja",
    "notYet": "Noch nicht",
    "notInterested": "Kein Interesse",
    "loading": "Lädt…",
    "retry": "Nochmal versuchen",
    "offline": "Du bist offline. Wir zeigen den zuletzt geladenen Stand.",
    "points": "{count, plural, one {# Punkt} other {# Punkte}}",
    "days": "{count, plural, one {# Tag} other {# Tage}}",
    "dayOf": "Tag {day} von {total}",
    "sessionOf": "Session {n} von {total}",
    "error": "Da ist etwas schiefgelaufen.",
    "optional": "optional",
    "today": "Heute",
    "watch": "Ansehen",
    "copy": "Kopieren",
    "justNow": "gerade eben",
    "report": "Melden",
    "block": "Person blockieren",
    "offlinePending": "{n} warten auf Sync"
  },
  "onboarding": {
    "welcomeTitle": "Hey. Schön, dass du da bist.",
    "welcomeBody": "Tageswort, Gebet, Challenges und deine Community — alles an einem Ort.",
    "start": "Los geht's",
    "whereTitle": "Wo startest du?",
    "guest": "Erstmal umschauen",
    "guestHint": "Ohne Konto. Deine Daten bleiben auf diesem Gerät.",
    "account": "Konto anlegen",
    "accountHint": "Nur E-Mail. Journal, Zertifikate und Punkte bleiben bei dir — auch auf einem neuen Gerät.",
    "signInApple": "Mit Apple fortfahren",
    "signInGoogle": "Mit Google fortfahren",
    "signInEmail": "Mit E-Mail fortfahren",
    "emailLabel": "E-Mail",
    "nameLabel": "Vollständiger Name",
    "aliasLabel": "Wie sollen wir dich nennen?",
    "magicSent": "Schau in dein Postfach",
    "magicSentBody": "Wir haben einen Anmeldelink an {email} geschickt. Öffne ihn auf diesem Gerät.",
    "churchTitle": "Deine Kirche",
    "churchBody": "Wähle deine Kirche, um ihre Inhalte, Fams und die Gebetswand zu sehen.",
    "churchOther": "Eine andere Kirche",
    "churchOtherLabel": "Name deiner Kirche",
    "churchNone": "Ich gehöre zu keiner Kirche",
    "langTitle": "Sprache",
    "langHint": "Du kannst das später ändern.",
    "aliasTitle": "Wie sollen wir dich nennen?",
    "aliasBody": "Dein Name in Fams, Challenges und auf der Gebetswand.",
    "finish": "Fertig",
    "skip": "Überspringen",
    "firstStepsKicker": "ZWEI ERSTE SCHRITTE",
    "firstStepsTitle": "Wo willst du anfangen?",
    "firstStepsBody": "Such dir eins aus. Zu den anderen kannst du jederzeit zurück.",
    "firstStepShotKicker": "3 MINUTEN",
    "firstStepShot": "Einen Hey Shot ansehen",
    "firstStepChallengeKicker": "MIT ANDEREN",
    "firstStepChallenge": "Eine Challenge wählen",
    "firstStepAskKicker": "ANONYM",
    "firstStepAsk": "Eine Frage stellen"
  },
  "guest": {
    "lockedTitle": "Sichere das mit einem Konto",
    "lockedBody": "Journal, Zertifikate und Punkte bleiben bei dir — auch auf einem neuen Gerät. Nur E-Mail.",
    "upgrade": "Konto anlegen",
    "keepLooking": "Weiter umschauen",
    "localOnly": "Nur auf diesem Gerät gespeichert",
    "dataLoss": "Ohne Konto bleibt alles, was du hier machst, nur auf diesem Handy. Löschst du die App oder wechselst das Gerät, ist es weg."
  },
  "home": {
    "dailyWordKicker": "TAGESWORT",
    "startPrayer": "Gebet starten · 1 Min",
    "celebrationKicker": "LETZTE CELEBRATION",
    "activeQuest": "Deine Quest",
    "checkInToday": "Heute einchecken",
    "nextWave": "Nächste Welle",
    "nextWaveBody": "Eine neue Challenge startet {date}. Mach mit und bring jemanden mit.",
    "balanceRing": "Balance",
    "balanceLocked": "Dein Balance-Ring öffnet sich mit einem Konto.",
    "oneThing": "Eine Sache heute",
    "oneThingDone": "Für heute erledigt",
    "season": "Season · Woche {week} von {weeks}",
    "watchCelebration": "Celebration ansehen",
    "oneThingHint": "Tippe, wenn du es getan hast.",
    "questProgress": "{n} Check-ins",
    "openQuest": "Zur Quest",
    "seasonKicker": "SEASON",
    "readMore": "Mehr lesen",
    "goodMorning": "Guten Morgen",
    "goodDay": "Hey",
    "goodEvening": "Guten Abend",
    "nudgeContinue": "Weiter",
    "nudgeNotInterested": "Kein Interesse",
    "nudgeSession": "Session {x} von {y} · {n} Fragen · 1 Reflexion",
    "nudgeKicker": "GROW · FRAGEN OFFEN",
    "nudgeBody": "Du hast das Video gesehen, aber die Fragen sind noch offen. In zwei Minuten bist du durch.",
    "balanceHint": "Deine letzten 7 Tage für Körper, Kopf, Herz und Geist.",
    "balanceA11y": "Balance-Ring, {percent} Prozent deines Wochenrhythmus",
    "ring": {
      "body": "Körper",
      "mind": "Kopf",
      "heart": "Herz",
      "spirit": "Geist"
    }
  },
  "prayer": {
    "ofTheDay": "Gebet des Tages",
    "iPrayed": "Ich habe gebetet",
    "prayedCount": "{count, plural, =0 {Noch niemand hat gebetet} one {# Person hat gebetet} other {# Personen haben gebetet}}",
    "shareCard": "Gebetskarte teilen",
    "sendToFam": "An meine Hey Fam senden",
    "wall": "Gebetswand",
    "newRequest": "Neues Anliegen",
    "anonymous": "Anonym posten",
    "urgent": "Dringend",
    "visibleIn": "Sichtbar in {where}",
    "visibleFam": "deiner Hey Fam",
    "visibleChurch": "deiner Kirche",
    "visibleAll": "der ganzen Hey Life Community",
    "answered": "Erhört",
    "markAnswered": "Als erhört markieren",
    "withdraw": "Zurückziehen",
    "dailyLimit": "Du kannst bis zu 3 Anliegen am Tag posten.",
    "start": "Beten",
    "prayedToday": "Heute schon gebetet",
    "cardReady": "Deine Gebetskarte",
    "cardBody": "Teile das Gebet mit jemandem, der es heute braucht.",
    "forSomeone": "Für jemanden beten",
    "amenPoints": "+{n} Punkte fürs Beten",
    "shared": "Geteilt · +{n} Punkte",
    "minute": "{n} Min",
    "open": "Offen",
    "answeredFilter": "Erhört",
    "mine": "Meine",
    "composerPlaceholder": "Wofür dürfen wir beten?",
    "category": "Kategorie",
    "post": "Anliegen teilen",
    "posted": "Geteilt. {points} Punkte.",
    "cat": {
      "health": "Gesundheit",
      "family": "Familie",
      "work": "Arbeit",
      "faith": "Glaube",
      "relationships": "Beziehungen",
      "finances": "Finanzen",
      "other": "Sonstiges"
    },
    "anonymousLabel": "Anonym",
    "urgentLabel": "Dringend",
    "nowVisible": "Gerade sichtbar in {where}",
    "escalatesAt": "Geht um {time} an die ganze Gemeinde, wenn niemand betet.",
    "prayedBtn": "Ich habe gebetet",
    "prayedDone": "Gebetet",
    "wallEmpty": "Hier gibt es noch keine Anliegen.",
    "answeredNote": "Wie wurde es erhört? (optional)",
    "withdrawn": "Zurückgezogen.",
    "crisisNote": "Das klingt schwer. Jemand aus deiner Gemeinde meldet sich. Du bist nicht allein.",
    "guestWallHint": "Als Gast siehst du Anliegen, die mit allen geteilt sind.",
    "forName": "Für {name}"
  },
  "grow": {
    "paths": "Wege",
    "shots": "Hey Shots",
    "shot": "Hey Shot",
    "sessionKicker": "SESSION {n} VON {total}",
    "questionsOpen": "GROW · FRAGEN OFFEN",
    "nudgeTitle": "Du hast das Video gesehen. Deine Fragen warten.",
    "remindNext": "Beim nächsten Mal erinnern",
    "remindMore": "Erinnern · noch {n}",
    "remindToast": "Okay — wir erinnern dich, wenn du die App das nächste Mal öffnest.",
    "lastReminder": "Letzte Erinnerung. Danach fragen wir nicht mehr.",
    "oneThought": "Ein Gedanke",
    "oneThoughtTitle": "Wachstum passiert nicht durch Zuschauen — sondern durch Nachdenken.",
    "continueAfterAll": "Doch weitermachen",
    "watchAnother": "Anderes Video ansehen",
    "toReflection": "Zur Reflexion",
    "nextQuestion": "Nächste Frage",
    "prevQuestion": "Vorherige Frage",
    "watchAgain": "Video nochmal ansehen",
    "correct": "Richtig",
    "wrong": "Nicht ganz",
    "whatContentSaid": "Was der Inhalt gesagt hat",
    "reflectionToFam": "Mit meiner Hey Fam teilen",
    "reflectionToJournal": "Privat ins Journal",
    "certificate": "Zertifikat",
    "askAnonymously": "Anonym eine Frage stellen",
    "questionSent": "Gesendet. Jemand aus dem Team antwortet dir in der App.",
    "startSession": "Session starten",
    "continueSession": "Weitermachen",
    "locked": "Schließe zuerst die vorherige Session ab.",
    "watch": "Video ansehen",
    "toQuestions": "Zu den Fragen",
    "videoWatched": "Video gesehen",
    "stepCard": "Dein Schritt",
    "reflectionTitle": "Reflexion",
    "reflectionPlaceholder": "Was nimmst du mit?",
    "myQuestions": "Meine Fragen",
    "questionPlaceholder": "Deine Frage an das Team …",
    "answerPending": "Antwort kommt in der App",
    "pathDone": "Weg abgeschlossen",
    "certificateEarned": "Du hast ein Zertifikat verdient",
    "shareCertificate": "Zertifikat teilen",
    "completedOf": "{done} von {total} Sessions",
    "earnedPoints": "+{n} Punkte",
    "sessionDone": "Session abgeschlossen",
    "sessionDoneBody": "Stark. Dein nächster Schritt wartet.",
    "noShots": "Noch keine Shots.",
    "shotsBody": "Kurze Impulse aus deiner Gemeinde.",
    "pathsBody": "Videos, Fragen, ein Schritt. Session für Session.",
    "questionsLeft": "{n} Fragen",
    "question": "Frage {n} von {total}",
    "yes": "Ja",
    "no": "Nein",
    "reflectionSaved": "Gespeichert.",
    "famNeeded": "Du brauchst eine Hey Fam, um dort zu teilen.",
    "toCertificates": "Meine Zertifikate"
  },
  "challenges": {
    "title": "Challenges",
    "join": "Mitmachen",
    "invite": "Jemanden einladen",
    "inviteBody": "Teile deinen Link. Wer darüber einsteigt, startet an deinem Tag.",
    "checkIn": "Einchecken",
    "checkedIn": "Eingecheckt",
    "addPhoto": "Foto hinzufügen",
    "completeTitle": "Du hast es geschafft.",
    "completeBody": "{count} Check-ins. Eine Frage zum Nachdenken, bevor du gehst.",
    "chat": "Chat",
    "chatReadOnly": "Dieser Chat ist jetzt schreibgeschützt.",
    "totalOnCompletion": "{points} Punkte bei Abschluss",
    "stayTogether": "Als Fam zusammenbleiben?",
    "report": "Melden",
    "block": "Blockieren",
    "discover": "Entdecken",
    "filterDuration": "Dauer",
    "filterArea": "Lebensbereich",
    "all": "Alle",
    "noMatches": "Keine Treffer",
    "resetFilters": "Filter zurücksetzen",
    "short": "bis 9 Tage",
    "medium": "10–20 Tage",
    "long": "ab 21 Tage",
    "area": {
      "spirit": "Glaube",
      "body": "Körper",
      "mind": "Kopf",
      "relationships": "Beziehungen",
      "finances": "Finanzen",
      "work": "Arbeit",
      "leisure": "Freizeit"
    },
    "participants": "{count, plural, =0 {Noch niemand} one {# Person} other {# Personen}} dabei",
    "nextStart": "Nächster Start: {date}",
    "startToday": "Startet heute",
    "whatToExpect": "Was dich erwartet",
    "dailyRoutine": "Tägliche Routine",
    "dailyRoutineBody": "Ein Check-in am Tag: ein Satz, wenn du magst ein Foto.",
    "pointsPerDay": "{points} Punkte pro Tag",
    "joinToday": "Heutige Welle mitmachen",
    "joinOn": "Welle vom {date} mitmachen",
    "joined": "Du bist dabei.",
    "yourCohort": "Deine Welle",
    "openWaves": "Offene Wellen",
    "day": "Tag {day}",
    "dayOf": "Tag {day} von {total}",
    "skipped": "übersprungen",
    "missed": "verpasst",
    "checkedInDay": "Erledigt",
    "todayPrompt": "Heute",
    "checkInNote": "Ein Satz zu heute (optional)",
    "checkInSaved": "Eingecheckt. {points} Punkte.",
    "alreadyToday": "Du hast heute schon eingecheckt.",
    "missedBody": "Verpasste Tage sind okay. Mach einfach heute weiter.",
    "upcoming": "Startet am {date}",
    "upcomingBody": "Die Welle startet bald. Lade jemanden ein, um gemeinsam zu starten.",
    "finished": "Abgeschlossen",
    "members": "{count, plural, one {# Mitglied} other {# Mitglieder}}",
    "inviteLink": "Einladungslink",
    "copyLink": "Link kopieren",
    "linkCopied": "Kopiert.",
    "shareLink": "Link teilen",
    "completionReflection": "Was hat sich in diesen {days} Tagen für dich verändert?",
    "completionJournalHint": "Deine Antwort landet in deinem Journal.",
    "completionGuestHint": "Mit einem Account würde deine Antwort im Journal gespeichert.",
    "shareCard": "Abschlusskarte teilen",
    "cardFiled": "Deine Karte liegt unter Ich → Urkunden.",
    "chatPlaceholder": "Schreib deiner Welle…",
    "chatEmpty": "Noch hat niemand geschrieben. Sag hallo.",
    "guestName": "Du schreibst als {name}.",
    "reported": "Gemeldet. Wir haben es für dich ausgeblendet.",
    "blocked": "Blockiert. Du siehst keine Beiträge dieser Person mehr.",
    "reportReason": "Warum meldest du das?",
    "reportSent": "Danke. Das Team schaut es sich an.",
    "leave": "Challenge verlassen",
    "joinedViaInvite": "Du startest an Tag {day} – wie {name}.",
    "joinedViaInviteNoName": "Du startest an Tag {day}.",
    "inviteTitle": "Einladung",
    "inviteBodyLanding": "Mach bei der Welle mit und starte heute.",
    "activeTitle": "Deine Challenges",
    "past": "Abgeschlossen",
    "none": "Keine aktive Challenge. Such dir unten eine aus.",
    "checkInQueued": "Check-in auf diesem Handy gespeichert. Wird synchronisiert, sobald du wieder online bist."
  },
  "community": {
    "title": "Community",
    "sectionsOff": "Diese Gemeinde hat die Community ausgeschaltet.",
    "feed": "Feed",
    "myFam": "Meine Hey Fam",
    "famFinder": "Eine Hey Fam finden",
    "request": "Anfragen",
    "requested": "Angefragt",
    "requestedBody": "Die Leitung bestätigt. Wir sagen dir Bescheid.",
    "globalFam": "Hey Life Global",
    "globalFamBody": "Keine Hey Church in deiner Nähe? Komm in die globale Fam.",
    "full": "Voll",
    "spots": "{count, plural, one {noch # Platz} other {noch # Plätze}}",
    "makePrayer": "Zum Gebetsanliegen machen",
    "newPost": "Neuer Beitrag",
    "lockedBody": "Die Community öffnet sich mit einem Konto.",
    "prayerTab": "Gebet",
    "feedSoon": "Der Feed öffnet sich mit deiner Hey Fam.",
    "famSoon": "Hier findest du bald deine Hey Fam.",
    "famTab": "Hey Fam",
    "feedEmpty": "Noch nichts hier. Deine Gemeinde, deine Fam und deine Challenges posten hier.",
    "feedLockedTitle": "Der Feed öffnet sich mit einem Konto",
    "feedLockedBody": "Beiträge von deiner Gemeinde, deiner Fam und deinen Challenges — und deine eigenen.",
    "postPlaceholder": "Was beschäftigt dich?",
    "post": "Posten",
    "posted": "Gepostet.",
    "postNoScope": "Tritt einer Gemeinde oder der globalen Fam bei, um zu posten.",
    "fromChurch": "Gemeinde",
    "fromFam": "Fam",
    "fromChallenge": "Challenge",
    "deletePost": "Beitrag löschen",
    "yourFam": "Deine Hey Fam",
    "openChat": "Chat öffnen",
    "membersCount": "{count, plural, one {# Mitglied} other {# Mitglieder}}",
    "leader": "Leitung: {name}",
    "leave": "Fam verlassen",
    "leaveConfirm": "Diese Fam verlassen? Du kannst jederzeit eine neue anfragen.",
    "withdraw": "Anfrage zurückziehen",
    "requestedTitle": "Angefragt",
    "requestedPco": "Deine Gemeinde bestätigt die Anfrage im Church Center. Das dauert meist ein, zwei Tage — wir sagen dir Bescheid.",
    "requestedManual": "Deine Gemeinde bestätigt die Anfrage. Wir sagen dir Bescheid.",
    "finderTitle": "Hey Fams in deiner Nähe",
    "finderBody": "Kleine Gruppen, die sich jede Woche treffen. Such dir eine aus und frag an.",
    "finderEmpty": "Deine Gemeinde hat noch keine Fams eingetragen.",
    "pcoStale": "Letzte bekannte Liste — Planning Center ist gerade nicht erreichbar.",
    "openSeats": "{count, plural, =0 {Voll} one {# Platz frei} other {# Plätze frei}}",
    "online": "Online",
    "day": {
      "monday": "Montag",
      "tuesday": "Dienstag",
      "wednesday": "Mittwoch",
      "thursday": "Donnerstag",
      "friday": "Freitag",
      "saturday": "Samstag",
      "sunday": "Sonntag"
    },
    "requestSheetTitle": "Bei {fam} anfragen",
    "requestSheetBody": "Deine Anfrage geht an deine Gemeinde. Fams werden im Church Center verwaltet — du kannst dich auch direkt dort anmelden. Die Karte zeigt „Angefragt“, bis die Gemeinde bestätigt.",
    "requestSheetConfirm": "Anfrage senden",
    "openChurchCenter": "Church Center öffnen",
    "requestSent": "Anfrage gesendet.",
    "famFull": "Diese Fam ist gerade voll.",
    "matchTitle": "Nichts dabei?",
    "matchBody": "Sag deiner Gemeinde Bescheid und lass dich innerhalb von 48 Stunden vermitteln.",
    "matchCta": "Vermitteln lassen",
    "matchArea": "Stadtteil (optional)",
    "matchDay": "Wunschtag (optional)",
    "matchNote": "Gibt es etwas, das wir wissen sollten? (optional)",
    "matchSent": "Deine Gemeinde meldet sich innerhalb von 48 Stunden.",
    "matchPending": "Vermittlung angefragt — deine Gemeinde meldet sich.",
    "globalJoin": "Beitreten",
    "globalJoined": "Willkommen in der globalen Hey Fam.",
    "globalCardBody": "Eine Fam für alle ohne Hey Church in der Nähe. {count, plural, one {# Mitglied} other {# Mitglieder}} von überall.",
    "chatTitle": "{fam} · Chat",
    "chatPlaceholder": "Schreib deiner Fam…",
    "chatEmpty": "Noch hat niemand geschrieben. Sag Hallo.",
    "notMember": "Nur Mitglieder können diesen Chat lesen.",
    "stayTitle": "Zusammenbleiben als Fam?",
    "stayBody": "{title} ist geschafft. Viele Wellen machen als Hey Fam weiter — such dir eine oder startet gemeinsam.",
    "stayYes": "Hey Fam finden",
    "stayNo": "Jetzt nicht"
  },
  "me": {
    "title": "Ich",
    "whatsUp": "Was gerade läuft",
    "credentials": "Zertifikate",
    "journal": "Journal",
    "prayFor": "Für wen ich bete",
    "myChurch": "Meine Kirche",
    "invest": "Investieren",
    "talk": "Mit jemandem sprechen",
    "talkBody": "Erzähl uns, was los ist. Jemand aus dem Seelsorge-Team meldet sich.",
    "talkSent": "Jemand meldet sich bei dir.",
    "myTeam": "Mein Team",
    "teamKicker": "MEIN TEAM · HEY CHURCH",
    "openTeamPage": "Team-Seite öffnen",
    "teamHint": "Die App merkt sich nur, dass du getippt hast.",
    "teamCheckinKicker": "CHECK-IN · 4 WOCHEN SPÄTER",
    "teamCheckinTitle": "Vor vier Wochen hast du dir die Teams angeschaut. Wo stehst du jetzt?",
    "teamTrying": "Ich probiere es aus",
    "teamArrived": "Ich bin in einem Team angekommen",
    "teamNoContact": "Noch kein Kontakt",
    "teamNotInterested": "Gerade kein Interesse",
    "quickQuestion": "KURZE FRAGE",
    "whyNot": "Schade — hilfst du uns zu verstehen, warum?",
    "haveTeam": "Ich habe schon ein Team",
    "unsure": "Ich weiß nicht, welches Team zu mir passt",
    "tellWhy": "Erzähl uns, warum du kein Interesse hast",
    "points": "Punkte",
    "history": "Verlauf",
    "rewards": "Belohnungen",
    "nextReward": "Noch {remaining} bis {reward}",
    "redeem": "Einlösen",
    "redeemable": "Einlösbar",
    "requested": "Angefragt · {leader} meldet sich",
    "sent": "Gesendet",
    "leaderboard": "Rangliste",
    "leaderboardOptOut": "Mich in der Rangliste verbergen",
    "account": "Konto",
    "language": "Sprache",
    "notifications": "Mitteilungen",
    "quietHours": "Ruhezeiten",
    "privacy": "Datenschutz",
    "imprint": "Impressum",
    "terms": "Nutzungsbedingungen",
    "legalTabApp": "App",
    "legalTabChurch": "{church}",
    "legalTabChurchFallback": "Hey Church",
    "legalEmpty": "Für diesen Tab gibt es noch keinen Text.",
    "signOut": "Abmelden",
    "deleteAccount": "Konto löschen",
    "deleteBody": "Deine Daten werden nach 30 Tagen entfernt. Bis dahin kannst du dich wieder anmelden und abbrechen.",
    "followJesus": "Ich will Jesus nachfolgen",
    "saidYes": "Du hast Ja gesagt.",
    "bookTalk": "Gespräch buchen",
    "confirmSlot": "Bestätigen · {day} {time}",
    "pickSlot": "Tag, Uhrzeit und E-Mail",
    "care": "Seelsorge",
    "pointsTotal": "{n} Punkte gesammelt",
    "noCertificates": "Noch keine Zertifikate. Schließe einen Grow-Weg ab.",
    "noPoints": "Noch keine Punkte. Bete, lerne, mach mit.",
    "certificatesBody": "Alles, was du abgeschlossen hast.",
    "alias": "Anzeigename",
    "certificatesChallenge": "Challenge-Karten",
    "gymUnits": "{n, plural, =0 {Noch keine Gym-Einheiten} one {# Gym-Einheit} other {# Gym-Einheiten}}",
    "journalEntries": "{n, plural, =0 {Journal leer} one {# Journaleintrag} other {# Journaleinträge}}",
    "verseToday": "Vers des Tages",
    "noVerse": "Heute kein Vers",
    "groupHeyChurch": "Hey Church",
    "groupGlobalPlus": "Global+",
    "groupGlobal": "Global",
    "groupGuest": "Gast",
    "certificatesCount": "{n, plural, =0 {Noch keine Zertifikate} one {# Zertifikat} other {# Zertifikate}}",
    "guestHint": "Melde dich an, damit Journal, Namen und Punkte auf allen Geräten bleiben.",
    "signIn": "Anmelden",
    "journalBody": "Privat und verschlüsselt. Nur du kannst es lesen — nie deine Kirche, nie das Care-Team.",
    "journalGate": "Dein Journal braucht ein Konto, damit es privat und verschlüsselt bleibt.",
    "journalEmpty": "Noch nichts hier. Abschluss-Reflexionen und eigene Notizen landen hier.",
    "journalNew": "Neuer Eintrag",
    "journalPlaceholder": "Was beschäftigt dich heute?",
    "journalSave": "Speichern",
    "journalExport": "Exportieren",
    "journalDelete": "Eintrag löschen",
    "journalDeleteConfirm": "Diesen Eintrag endgültig löschen?",
    "journalKindFree": "Notiz",
    "journalKindReflection": "Abschluss-Reflexion",
    "journalKindPrompt": "Impuls",
    "journalExportTitle": "Mein Hey-Life-Journal",
    "namesBody": "Bis zu drei Namen. Sie erscheinen, wenn du das Gebet des Tages betest.",
    "namesAdd": "Namen hinzufügen",
    "namesPlaceholder": "Name",
    "namesSince": "seit {date}",
    "namesPrayNow": "Jetzt beten",
    "namesMax": "Drei Namen sind das Limit — entferne zuerst einen.",
    "namesEmpty": "Noch keine Namen.",
    "namesGate": "Für wen du betest, bleibt bei deinem Konto.",
    "namesRemove": "Entfernen",
    "fam": "Hey Fam",
    "famNone": "Noch keine Fam",
    "famRequested": "Angefragt",
    "famMember": "{name}",
    "investBody": "Dein Geben hält Hey Life für alle kostenlos und stärkt deine Kirche.",
    "investBodyHeyChurch": "Dein Geben trägt {church} und hält Hey Life für alle kostenlos.",
    "investOnce": "Einmalig",
    "investMonthly": "Monatlich",
    "investGive": "{amount} geben",
    "investOther": "Anderer Betrag",
    "investThanksHeyChurch": "Danke, dass du in {church} investierst.",
    "investThanksOther": "Danke, dass du in Hey Life investierst.",
    "investUnavailable": "Geben ist noch nicht eingerichtet.",
    "talkPlaceholder": "Was ist los?",
    "talkContact": "Wie erreichen wir dich? (optional)",
    "talkContactPlaceholder": "Telefon, E-Mail oder Instagram",
    "talkAnonymous": "Anonym bleiben",
    "talkAnonymousHint": "Anonyme Anfragen können nicht persönlich beantwortet werden.",
    "talkSend": "Senden",
    "talkOpen": "Gesendet {when} · jemand meldet sich",
    "talkInContact": "{alias} aus dem Pastoralteam ist mit dir in Kontakt.",
    "talkTeam": "Jemand aus dem Pastoralteam ist mit dir in Kontakt.",
    "talkNoChurch": "Deine Anfrage geht an das Hey-Life-Care-Team.",
    "churchHeyChurch": "Du gehörst zu {church}, einer Hey Church. Alles in der App ist auf deine Kirche abgestimmt.",
    "churchGlobalPlus": "Du gehörst zu {church}. Hey Life begleitet dich — Global+.",
    "churchGlobal": "Du hast keine Kirche gewählt. Du bist in der Global-Gruppe.",
    "chooseChurch": "Kirche wählen",
    "switchChurch": "Kirche wechseln",
    "switchNeedsAdmin": "Ein weiterer Wechsel braucht deinen Kirchen-Admin.",
    "switchStaff": "Teammitglieder können ihre Kirche hier nicht verlassen.",
    "settingsTitle": "Einstellungen",
    "notifFamCohort": "Fam & Challenges",
    "notifRhythm": "Täglicher Rhythmus",
    "notifProgress": "Fortschritt",
    "notifPersonal": "Persönlich",
    "notifLocked": "Benachrichtigungen brauchen ein Konto.",
    "notifBody": "Max. drei Fam-Pushes und ein Rhythmus-Push pro Tag. Ruhezeiten halten alles zurück außer Krisenalarmen.",
    "quietFrom": "Von",
    "quietTo": "Bis",
    "deleteConfirm": "Mein Konto löschen",
    "deleteRequested": "Löschung beantragt · deine Daten werden am {date} entfernt.",
    "deleteCancel": "Konto behalten",
    "deleteGuest": "Als Gast verschwinden deine Daten sofort.",
    "languageDe": "Deutsch",
    "languageEn": "English",
    "appearance": "Darstellung",
    "appearanceBody": "System folgt der Hell/Dunkel-Einstellung deines Telefons.",
    "theme_system": "System",
    "theme_light": "Hell",
    "theme_dark": "Dunkel",
    "sentryDevTitle": "Diagnose",
    "sentryDevBody": "Testereignis an Sentry senden (nur Nicht-Produktion).",
    "sentryTestMessage": "Sentry-Testnachricht",
    "sentryTestCrash": "Sentry-Testabsturz",
    "sentryTestSent": "Testereignis an Sentry gesendet. In etwa einer Minute unter Issues (Umgebung: development) prüfen.",
    "careKicker": "CARE · {church}",
    "careBody": "Anfragen, dringende Gebete und Entscheidungen deiner Kirche.",
    "pushPermission": "Benachrichtigungen erlauben",
    "gym": "Hey Gym",
    "teamBody": "Mach mit: Die Teams von {church} findest du auf der Website. Die App merkt sich nur, dass du geschaut hast.",
    "teamNoUrl": "Deine Gemeinde hat noch keinen Team-Link hinterlegt.",
    "teamAnswered": "Danke — notiert.",
    "teamFinished": "Check-ins abgeschlossen. Danke dir.",
    "teamNextCheck": "Nächster Check-in {date}",
    "teamLookedAt": "Teams angeschaut {date}",
    "teamSend": "Senden",
    "teamRatherNot": "Lieber nicht",
    "rewardsBody": "Meilensteine deiner Gemeinde. Jede Belohnung kann einmal eingelöst werden.",
    "rewardLocked": "Noch {n} Punkte",
    "rewardRedeemed": "Eingelöst",
    "rewardDateSet": "Termin steht · {leader} meldet sich",
    "rewardResend": "Mail erneut senden",
    "rewardResent": "Mail gesendet.",
    "pickLeader": "Wen möchtest du treffen?",
    "yourPhone": "Deine Telefonnummer",
    "redeemConfirm": "{reward} einlösen",
    "redeemLeaderBody": "{leader} meldet sich bei dir, um einen Termin zu finden.",
    "redeemBookBody": "Wir schicken das Buch sofort an {email}.",
    "redeemPhysicalBody": "Deine Gemeinde bereitet es vor und meldet sich.",
    "nextRewardKicker": "NÄCHSTE BELOHNUNG",
    "allRewardsReached": "Du hast jede Belohnung erreicht. Wow.",
    "leaderboardFam": "Hey Fam",
    "leaderboardChurch": "Hey Church",
    "leaderboardEmpty": "Noch niemand hier.",
    "leaderboardNoFam": "Tritt einer Hey Fam bei, um ihre Rangliste zu sehen.",
    "leaderboardNoChurch": "Wähle eine Hey Church, um ihre Rangliste zu sehen.",
    "leaderboardHidden": "Du bist in der Rangliste ausgeblendet. Die Liste siehst du trotzdem.",
    "leaderboardGuest": "Gäste erscheinen nicht.",
    "you": "Du",
    "rank": "#{n}",
    "decideKicker": "JESUS NACHFOLGEN",
    "decideBody": "Ja zu Jesus zu sagen ist der Anfang von allem. Wir reden gern mit dir darüber.",
    "decideCta": "Ich will Jesus nachfolgen",
    "decideThanks": "Du hast Ja gesagt — wir freuen uns riesig.",
    "letsTalk": "Lass uns reden",
    "letsTalkBody": "Buch einen Termin mit jemandem aus deiner Gemeinde oder lass dich anrufen.",
    "bookSlot": "Termin buchen",
    "callMe": "Lieber angerufen werden",
    "callMeBody": "Bestätige deine Nummer, dann ruft dich jemand an.",
    "phonePlaceholder": "+49 …",
    "callRequested": "Notiert · jemand ruft dich an unter {phone}",
    "slotBooked": "Dein Gespräch: {date}",
    "talkHeld": "Gespräch geführt. Danke dir.",
    "noCalendly": "Buchung ist für deine Gemeinde noch nicht eingerichtet — lass dich stattdessen anrufen.",
    "baptismKicker": "TAUF-HEY-FAM",
    "baptismInvited": "Du bist zur Tauf-Hey-Fam eingeladen.",
    "baptismQuestion": "Hast du dich schon angemeldet?",
    "baptismSignedUp": "Du bist für die Tauf-Hey-Fam angemeldet.",
    "baptismYes": "Ja",
    "baptismNotYet": "Noch nicht",
    "decideGuest": "Erstelle ein Konto, damit deine Gemeinde dich erreichen kann.",
    "decideBodyOpen": "Jemand aus deiner Gemeinde meldet sich. Möchtest du jetzt einen Termin buchen?",
    "teamQuickQuestion": "KURZE FRAGE",
    "teamWhyTitle": "Schade – hilfst du uns zu verstehen, warum?",
    "teamHaveTeam": "Ich habe schon ein Team",
    "teamUnsure": "Ich weiß nicht, welches Team passt",
    "teamWhyPlaceholder": "Sag uns, warum du kein Interesse hast",
    "decideTitle": "Jesus nachfolgen",
    "nextRewardBody": "Noch {n} Punkte bis {title}",
    "allRewards": "Alle Belohnungen",
    "redeemLeaderPick": "Wen möchtest du treffen?",
    "redeemSend": "Jetzt einlösen",
    "rewardRequested": "Angefragt – deine Gemeinde meldet sich.",
    "rewardSent": "Verschickt",
    "pointsGuest": "Punkte bleiben auf diesem Gerät, bis du ein Konto anlegst.",
    "confirmationSent": "Bestätigung an {email} geschickt",
    "leaderboardOptOutBody": "Deine Punkte zählen weiter; nur dein Name verschwindet aus den Listen.",
    "journalQueued": "Auf diesem Handy gespeichert. Wird synchronisiert, sobald du wieder online bist."
  },
  "gym": {
    "title": "Hey Gym",
    "quizKicker": "HEY GYM · {step}",
    "goalTitle": "Was ist dein Ziel?",
    "burnFat": "Fett verbrennen",
    "burnFatSub": "Abnehmen, leichter werden",
    "buildMuscle": "Muskeln aufbauen",
    "buildMuscleSub": "Stärker werden",
    "stayFit": "Fit bleiben",
    "stayFitSub": "Beweglich, ausdauernd, im Rhythmus",
    "analysisTitle": "Eine kurze Analyse",
    "weight": "Gewicht",
    "height": "Größe",
    "age": "Alter",
    "sex": "Geschlecht",
    "limitations": "Operationen, Erkrankungen, Verletzungen",
    "privacyLine": "Nur du siehst das. Nie deine Kirche, nie das Care-Team.",
    "freqTitle": "Wie oft pro Woche?",
    "planPreview": "DEIN PLAN WIRD",
    "planPreviewBody": "{goal} · {n}× pro Woche · 6 Wochen · {sessions} Einheiten",
    "createPlan": "Plan erstellen",
    "planCreated": "Plan erstellt · Woche 1 startet heute",
    "yourPlan": "DEIN PLAN · WOCHE {week} VON 6",
    "planSub": "{n} Einheiten pro Woche · aus deinem Fragebogen · {goal}",
    "sessionsOf": "{x} von {y} Einheiten · Zertifikat nach Woche 6",
    "startSession": "Einheit starten",
    "newPlan": "Neuer Plan",
    "certTitle": "Sechs Wochen. Jede Einheit. Du.",
    "certKicker": "ZERTIFIKAT · HEY GYM",
    "shareCert": "Zertifikat teilen",
    "newPlanNotice": "NEUER PLAN · HINWEIS",
    "progressLost": "Dein aktueller Fortschritt geht verloren.",
    "pointsStay": "Punkte, die du schon hast, bleiben.",
    "yesNewPlan": "Ja, neuen Plan starten",
    "keepPlan": "Meinen Plan behalten",
    "goal_burn_fat": "Fett verbrennen",
    "goal_build_muscle": "Muskeln aufbauen",
    "goal_stay_fit": "Fit bleiben",
    "step": "{n} / 3",
    "sexF": "w",
    "sexM": "m",
    "sexX": "x",
    "perWeek": "{n}×",
    "todayKicker": "HEUTE",
    "todaySession": "Einheit {n}",
    "todayDone": "Einheit geschafft — bis zum nächsten Mal.",
    "sessionDone": "+{points} Punkte · Einheit {x} von {y}",
    "sets": "{sets} × {reps}",
    "weekOf": "Woche {w}",
    "unitsLabel": "{x} von {y} Einheiten",
    "certBody": "{alias} · {y} von {y} Einheiten · abgeschlossen am {date}",
    "planPoints": "+{points}",
    "privacyShort": "Gesundheitsdaten bleiben bei dir.",
    "noPlanYet": "Noch kein Plan",
    "guestNote": "Dein Plan wird mit deinem Konto gespeichert.",
    "phaseDone": "Plan abgeschlossen",
    "exerciseInstructions": "So geht's",
    "optionalHint": "Alle Felder sind optional."
  },
  "care": {
    "today": "Heute",
    "decisions": "Entscheidungen",
    "cases": "Seelsorge",
    "takeOver": "Übernehmen",
    "statusOpen": "Offen",
    "statusInContact": "In Kontakt",
    "statusClosed": "Abgeschlossen",
    "anonymousRequest": "Anonyme Anfrage",
    "urgentRequests": "Dringende Gebetsanliegen",
    "talkRequests": "Gesprächsanfragen",
    "noneToday": "Gerade wartet nichts.",
    "takenBy": "{alias} kümmert sich",
    "takenByMe": "Du kümmerst dich",
    "needsAnswer": "Braucht eine Antwort",
    "saidYes": "Ja gesagt {when}",
    "talkBooked": "Gespräch {when}",
    "contact": "Kontakt: {contact}",
    "noContact": "Kein Kontakt angegeben",
    "close": "Abschließen",
    "reopen": "Wieder öffnen",
    "decisionsEmpty": "Keine Entscheidungen offen.",
    "casesEmpty": "Keine Fälle.",
    "heyLifeTeam": "Hey-Life-Care-Team",
    "source_talk_to_someone": "Jemand zum Reden",
    "source_crisis_flag": "Krisenwortlaut",
    "source_manual": "Manuell",
    "filterAll": "Alle",
    "prayed": "{n, plural, one {# hat gebetet} other {# haben gebetet}}",
    "takenByOther": "Jemand anders hat das schon übernommen."
  },
  "notifications": {
    "dailyWordTitle": "Dein Wort für heute",
    "checkInReminderTitle": "Noch offen: dein Check-in heute",
    "newMessages": "{count, plural, one {# neue Nachricht} other {# neue Nachrichten}} in {room}",
    "prayedForYou": "{count, plural, one {# Person hat} other {# Personen haben}} für dein Anliegen gebetet",
    "famConfirmed": "Willkommen bei {fam}",
    "challengeComplete": "Challenge abgeschlossen",
    "certificate": "Zertifikat erhalten",
    "rewardReached": "Du hast {reward} erreicht",
    "crisisAlert": "Dringend: eine Nachricht braucht deine Aufmerksamkeit"
  },
  "email": {
    "magicSubject": "Dein Anmeldelink für Hey Life",
    "magicBody": "Tippe auf den Link, um dich anzumelden. Er ist 10 Minuten gültig.",
    "magicButton": "Anmelden",
    "yesSubject": "Du hast Ja gesagt",
    "bookSubject": "30 Tage mit Gott — dein Buch",
    "deleteSubject": "Dein Hey Life Konto wird gelöscht",
    "inviteSubject": "Einladung ins Hey Life Command Center · {church}",
    "footer": "Hey Kirche e.V. · Owiesenstraße 66 · 22177 Hamburg · office@heychurch.de",
    "inviteBody": "Du wurdest eingeladen, {church} im Hey Life Command Center zu verwalten. Melde dich mit dieser E-Mail-Adresse an; der zweite Faktor wird beim ersten Login eingerichtet.",
    "inviteButton": "Command Center öffnen",
    "deletionTitle": "Wir löschen dein Konto",
    "deletionBody": "Deine Hey-Life-Daten werden am {date} entfernt. Wenn du es dir anders überlegst, melde dich vorher einfach wieder an — das bricht die Löschung ab.",
    "yesTitle": "Du hast Ja gesagt.",
    "yesBody": "Hey {name}, du hast Ja gesagt zu einem Leben mit Jesus. Das ist die beste Entscheidung deines Lebens. Jemand aus deiner Gemeinde meldet sich — oder du buchst direkt in der App ein Gespräch.",
    "yesFooter": "Diese Mail kommt genau einmal, egal wie viele Punkte du hast.",
    "bookTitle": "Dein Buch: {title}",
    "bookBody": "Hier ist deine Belohnung: {title}. Du kannst diese Mail jederzeit im Ich-Tab erneut anfordern.",
    "bookButton": "Buch öffnen",
    "bookTalkTitle": "Lass uns über dein Ja reden",
    "bookTalkBody": "Vor zwei Tagen hast du Ja gesagt. Such dir einen Termin mit jemandem aus deiner Gemeinde — oder lass dich in der App anrufen.",
    "bookTalkButton": "Termin buchen",
    "pdfSubject": "Nach unserem Gespräch",
    "pdfTitle": "Danke für das Gespräch",
    "pdfBody": "Hey {name}, im Anhang findest du, worüber wir gesprochen haben. Behalte es nah bei dir.",
    "digestSubject": "Deine Woche bei {church}",
    "digestTitle": "Deine Woche in Hey Life",
    "digestIntro": "Das ist in den letzten sieben Tagen bei {church} passiert. Nur Zahlen — Details findest du im Command Center.",
    "digestWau": "Aktive Menschen diese Woche",
    "digestNewUsers": "Neue Menschen",
    "digestCheckIns": "Check-ins",
    "digestPrayers": "Gebete des Tages gebetet",
    "digestSessions": "Grow-Sessions abgeschlossen",
    "digestGym": "Gym-Sessions",
    "digestFam": "Fam-Mitglieder bestätigt",
    "digestPoints": "Punkte vergeben",
    "digestOpenTitle": "Gerade offen",
    "digestOpenAlerts": "Needs Attention",
    "digestOpenRequests": "Gebetsanliegen ohne Antwort",
    "digestOpenCare": "Offene Care-Fälle",
    "digestButton": "Command Center öffnen",
    "digestFooter": "Du bekommst diese Mail, weil du Pastor:in oder Admin dieser Kirche bist. Deine Rolle änderst du im Command Center unter People & Roles."
  },
  "web": {
    "linkInvalid": "Dieser Link ist nicht mehr gültig",
    "startsOn": "Startet am {date}",
    "dayOf": "Tag {day} von {total}",
    "finished": "Abgeschlossen",
    "memberCount": "{count, plural, one {# Person} other {# Personen}} dabei",
    "joinInApp": "In der App mitmachen",
    "getApp": "Hey Life öffnen",
    "prayerNotFound": "Dieses Gebet wurde nicht gefunden"
  },
  "landing": {
    "title": "Dein Glaube.",
    "titleAccent": "Jeden Tag.",
    "tagline": "Hey Life ist die App von Hey Church: Tägliches Wort, Gebet, Challenges mit Freunden, Grow-Kurse und deine Fam. Für Hamburg, Berlin und überall.",
    "appStore": "Im App Store laden",
    "playStore": "Bei Google Play",
    "featuresTitle": "Was dich erwartet",
    "features": {
      "home": {
        "title": "Home",
        "body": "Tägliches Wort, Gebet des Tages und die nächste Celebration auf einen Blick."
      },
      "prayer": {
        "title": "Gebet",
        "body": "Bete für andere, teile Anliegen mit deiner Fam oder der ganzen Gemeinde."
      },
      "grow": {
        "title": "Grow",
        "body": "Kurse mit Video, Fragen und Reflexion. Mit Zertifikat am Ende."
      },
      "challenges": {
        "title": "Challenges",
        "body": "7 bis 30 Tage dranbleiben, gemeinsam mit Freunden und Chat."
      },
      "community": {
        "title": "Fam",
        "body": "Finde deine Kleingruppe, bleib in Kontakt, feiere zusammen."
      },
      "gym": {
        "title": "Hey Gym",
        "body": "Sechs Wochen Trainingsplan für deinen Körper, weil der auch dazugehört."
      }
    },
    "imprint": "Impressum",
    "privacy": "Datenschutz",
    "adminLogin": "Command Center",
    "madeBy": "Hey Kirche e.V."
  },
  "admin": {
    "errorBoundary": {
      "title": "Etwas ist schiefgelaufen",
      "body": "In der Konsole ist ein unerwarteter Fehler aufgetreten. Du kannst es erneut versuchen; wir wurden benachrichtigt.",
      "retry": "Erneut versuchen"
    },
    "login": {
      "title": "Command Center",
      "subtitle": "Anmeldung für Pastoren und Admins.",
      "email": "E-Mail",
      "password": "Passwort (nur Demo)",
      "sendLink": "Anmeldelink senden",
      "sent": "Link verschickt. Schau in dein Postfach.",
      "apiUnreachable": "Die API ist nicht erreichbar. Starte sie mit pnpm api im code-Ordner (Port 3000) und versuche es erneut.",
      "signInPassword": "Mit Passwort anmelden",
      "totpTitle": "Zweiter Faktor",
      "totpBody": "Gib den 6-stelligen Code aus deiner Authenticator-App ein.",
      "code": "Code",
      "verify": "Bestätigen",
      "noAccess": "Dein Konto hat keinen Zugang zum Command Center. Nur aktive Pastoren und Admins.",
      "signOut": "Abmelden",
      "back": "Zurück"
    },
    "nav": {
      "today": "Heute",
      "content": "Inhalte",
      "people": "People & Roles",
      "fams": "Fams",
      "prayer": "Gebetswand",
      "challenges": "Challenges",
      "notifications": "Benachrichtigungen",
      "settings": "Einstellungen",
      "questions": "Fragen",
      "churches": "Gemeinden",
      "moderation": "Moderation",
      "attention": "Needs Attention",
      "pulse": "Puls",
      "rewards": "Punkte & Belohnungen",
      "team": "Andere stärken",
      "decisions": "Jesus nachfolgen",
      "audit": "Protokoll"
    },
    "home": {
      "title": "Heute",
      "welcome": "Hallo {name}",
      "church": "Gemeinde",
      "status": "Status",
      "comingSoon": "Dieses Modul kommt im nächsten Meilenstein.",
      "platform": "Plattform",
      "role": "Rolle"
    },
    "scope": {
      "label": "Bereich",
      "global": "Global (alle Gemeinden)",
      "church": "Gemeinde"
    },
    "common": {
      "loading": "Lädt …",
      "error": "Etwas ist schiefgelaufen.",
      "save": "Speichern",
      "saved": "Gespeichert.",
      "cancel": "Abbrechen",
      "delete": "Löschen",
      "dragToReorder": "Ziehen zum Sortieren",
      "confirmDelete": "Wirklich löschen?",
      "new": "Neu",
      "back": "Zurück",
      "de": "Deutsch",
      "en": "Englisch",
      "yes": "Ja",
      "no": "Nein",
      "position": "Reihenfolge",
      "published": "Veröffentlicht",
      "draft": "Entwurf",
      "edit": "Bearbeiten",
      "close": "Schließen",
      "open": "Öffnen",
      "required": "Pflichtfeld"
    },
    "errors": {
      "generic": "Etwas ist schiefgelaufen. Bitte noch einmal versuchen.",
      "required": "Bitte {field} ausfüllen.",
      "invalid": "Bitte {field} prüfen.",
      "tooLong": "{field} ist zu lang.",
      "slug": "Der Kurzname braucht mindestens 2 Buchstaben oder Zahlen. Er wird klein geschrieben, Leerzeichen werden zu Bindestrichen.",
      "email": "Bitte eine gültige E-Mail-Adresse eingeben.",
      "url": "Bitte einen vollständigen Link eingeben, beginnend mit https://.",
      "fields": {
        "slug": "den Kurznamen",
        "name": "den Namen",
        "title": "den Titel",
        "title_de": "den deutschen Titel",
        "title_en": "den englischen Titel",
        "description": "die Beschreibung",
        "description_de": "die deutsche Beschreibung",
        "description_en": "die englische Beschreibung",
        "subtitle": "den Untertitel",
        "subtitle_de": "den deutschen Untertitel",
        "subtitle_en": "den englischen Untertitel",
        "dailyPrompt": "den Tagesimpuls",
        "dailyPrompt_de": "den deutschen Tagesimpuls",
        "dailyPrompt_en": "den englischen Tagesimpuls",
        "prompt": "die Frage",
        "prompt_de": "die deutsche Frage",
        "prompt_en": "die englische Frage",
        "explanation": "die Erklärung",
        "explanation_de": "die deutsche Erklärung",
        "explanation_en": "die englische Erklärung",
        "theme": "die Farbe",
        "email": "die E-Mail",
        "adminEmail": "die Admin-E-Mail",
        "videoId": "den YouTube-Link",
        "body": "den Text",
        "body_de": "den deutschen Text",
        "body_en": "den englischen Text"
      },
      "codes": {
        "forbidden": "Dafür fehlt die Berechtigung.",
        "not_found": "Das wurde nicht gefunden.",
        "validation": "Bitte das Formular prüfen und noch einmal speichern.",
        "invalid_body": "Bitte das Formular prüfen und noch einmal speichern.",
        "internal": "Etwas ist schiefgelaufen. Bitte noch einmal versuchen.",
        "church_required": "Bitte zuerst eine Gemeinde auswählen.",
        "invalid_youtube_link": "Bitte einen YouTube-Link oder eine 11-stellige Video-ID eingeben.",
        "url_or_id_required": "Bitte einen YouTube-Link oder eine 11-stellige Video-ID eingeben.",
        "reorder_mismatch": "Die Reihenfolge hat sich geändert. Seite neu laden und noch einmal versuchen.",
        "audience_required": "Bitte auswählen, wer die Nachricht bekommen soll.",
        "pdf_size": "Das PDF darf höchstens 10 MB groß sein.",
        "not_pdf": "Diese Datei ist kein PDF.",
        "celebration_url_not_youtube": "Der Link zum Gottesdienst muss ein YouTube-Link sein.",
        "invalid_theme": "Bitte eine Farbe aus der Liste wählen.",
        "slug_taken": "Diesen Kurznamen gibt es schon. Bitte ändern und noch einmal speichern.",
        "session_points_range": "Die Punkte pro Session müssen eine ganze Zahl von 0 bis 1000 sein.",
        "certificate_points_range": "Die Zertifikatspunkte müssen eine ganze Zahl von 0 bis 5000 sein.",
        "position_taken": "Diese Position ist schon vergeben. Bitte eine andere wählen.",
        "options_required": "Mindestens zwei Antworten, eine pro Zeile.",
        "correct_index_out_of_range": "Die Nummer der richtigen Antwort ist höher als die Anzahl der Antworten.",
        "invalid_question_id": "Diese Frage wurde nicht gefunden.",
        "invalid_answer": "Diese Antwort gehört nicht zu den Auswahlmöglichkeiten.",
        "totp_unavailable": "Die Authenticator-Einrichtung hat nicht gestartet. Bitte noch einmal versuchen."
      }
    },
    "today": {
      "week": "Letzte 7 Tage",
      "prayed": "Gebetet",
      "sessions": "Sessions abgeschlossen",
      "checkIns": "Challenge-Check-ins",
      "activeUsers": "Aktive Personen",
      "openQuestions": "Offene Fragen",
      "overdue": "{n} überfällig (> 48 h)",
      "scheduled": "Geplante Inhalte (nächste 3 Wochen)",
      "dailyWords": "Tagesworte",
      "dailyPrayers": "Gebete des Tages",
      "oneThings": "Eine Sache heute",
      "members": "Mitglieder",
      "days": "{n} Tage",
      "toQuestions": "Zu den Fragen",
      "toContent": "Inhalte planen",
      "attention": "Needs Attention",
      "attentionBody": "{count, plural, =0 {Nichts offen} one {# offener Eintrag} other {# offene Einträge}}, {overdue} überfällig",
      "toAttention": "Liste öffnen",
      "reports": "Offene Meldungen",
      "urgent": "Dringende Anliegen",
      "toPulse": "Puls",
      "toFams": "Fams",
      "famRequests": "Fam-Anfragen",
      "tasks": "Aufgaben",
      "rewardRequests": "{n, plural, one {# Belohnungsanfrage} other {# Belohnungsanfragen}}",
      "callTasks": "{n, plural, one {# persönlicher Anruf} other {# persönliche Anrufe}}",
      "approvals": "{n, plural, one {# Rollenfreigabe} other {# Rollenfreigaben}}",
      "teamFollowUps": "{n, plural, one {# Team-Nachfassen} other {# Team-Nachfassen}}",
      "openDecisions": "{n, plural, one {# Entscheidung wartet auf Kontakt} other {# Entscheidungen warten auf Kontakt}}",
      "sentToday": "Heute gesendet",
      "sentTodayBody": "{n} Nachrichten heute vom Team gesendet",
      "toRewards": "Punkte & Belohnungen",
      "toTeam": "Andere stärken",
      "toDecisions": "Gespräche",
      "toPeople": "Personen & Rollen",
      "toNotifications": "Benachrichtigungen"
    },
    "content": {
      "title": "Inhalte",
      "tabs": {
        "dailyWords": "Tageswort",
        "dailyPrayers": "Gebet des Tages",
        "oneThings": "Eine Sache heute",
        "paths": "Grow-Pfade",
        "shots": "Hey Shots",
        "seasons": "Seasons",
        "challenges": "Challenges",
        "cohorts": "Wellen"
      },
      "date": "Datum",
      "locale": "Sprache",
      "verseRef": "Bibelstelle",
      "verseText": "Verstext",
      "impulse": "Impuls",
      "voice": "Stimme (optional)",
      "prayerTitle": "Titel",
      "prayerBody": "Gebetstext (ein Absatz pro Zeile)",
      "durationSec": "Dauer (Sekunden)",
      "text": "Text",
      "empty": "Kein Eintrag",
      "globalFallback": "Global (wird angezeigt, solange ihr nichts eigenes eintragt)",
      "overlay": "Eigener Eintrag – überschreibt global",
      "today": "Heute",
      "window": "Zeitraum",
      "weeksAhead": "{n} Wochen voraus",
      "slug": "Slug",
      "pathTitle": "Titel",
      "description": "Beschreibung",
      "theme": "Farbe",
      "customColor": "Eigene Farbe",
      "hidePath": "Verbergen / Deaktivieren",
      "showPath": "Aktivieren / Veröffentlichen",
      "pathHidden": "Verborgen (Deaktiviert)",
      "pathVisible": "Sichtbar (Veröffentlicht)",
      "pathHiddenHint": "Mitglieder können diesen Pfad in der App nicht sehen oder starten",
      "pathVisibleHint": "Für Mitglieder in der App sichtbar",
      "pathDisabledToast": "Pfad verborgen und deaktiviert",
      "pathEnabledToast": "Pfad ist jetzt in der App sichtbar",
      "sessionPoints": "Punkte pro Session",
      "certificatePoints": "Punkte für Zertifikat",
      "sessions": "{n} Sessions",
      "openPath": "Pfad öffnen",
      "newPath": "Neuer Pfad",
      "newSession": "Neue Session",
      "newQuestion": "Neue Frage",
      "sessionTitle": "Titel",
      "videoId": "YouTube-Link oder Video-ID",
      "videoDuration": "Videolänge (Sekunden)",
      "youtubeFetch": "Daten abrufen",
      "youtubeFetching": "Infos werden geladen …",
      "invalidYoutube": "Gib einen YouTube-Link oder eine 11-stellige Video-ID ein.",
      "youtubeAutofilled": "Von YouTube übernommen",
      "previewCard": "Kachel-Vorschau",
      "defaultReflection": "Was nimmst du aus dieser Session für deinen Alltag mit?",
      "defaultStepCard": "Wende heute einen Gedanken im Alltag an.",
      "captions": "Untertitel vorhanden",
      "reflectionPrompt": "Reflexionsfrage",
      "stepCard": "Schritt-Karte (optional)",
      "questions": "Fragen",
      "prompt": "Frage",
      "options": "Antworten (eine pro Zeile)",
      "correctIndex": "Richtige Antwort (Nr.)",
      "explanation": "Erklärung",
      "kind": "Typ",
      "multipleChoice": "Multiple Choice",
      "yesNo": "Ja/Nein",
      "free": "Freie Frage",
      "noCorrectAnswer": "Keine feste Antwort (freie Frage)",
      "optionsNeedTwo": "Mindestens zwei Antworten, eine pro Zeile.",
      "optionsOptional": "Bei einer freien Frage optional. Eine Antwort pro Zeile.",
      "correctIndexRange": "Die Nummer der richtigen Antwort ist höher als die Anzahl der Antworten.",
      "shotTitle": "Titel",
      "newShot": "Neuer Shot",
      "seasonTitle": "Titel",
      "subtitle": "Untertitel",
      "startsOn": "Startet am",
      "weeks": "Wochen",
      "active": "Aktiv",
      "linkedPath": "Verknüpfter Pfad",
      "noPath": "Kein Pfad",
      "newSeason": "Neue Season",
      "readOnlyGlobal": "Globale Inhalte kann nur das Hey-Church-Team ändern.",
      "noRows": "Noch nichts angelegt.",
      "learners": "{n} Lernende",
      "certificates": "{n} Zertifikate",
      "challengeTitle": "Challenge",
      "dailyPrompt": "Tägliche Frage",
      "durationDays": "Dauer (Tage)",
      "lifeArea": "Lebensbereich",
      "dayPoints": "Punkte pro Tag",
      "completionPoints": "Abschlussbonus",
      "newChallenge": "Neue Challenge",
      "cohorts": "Wellen",
      "participants": "Teilnehmende",
      "completions": "Abschlüsse",
      "totalOnCompletion": "{points} bei Abschluss",
      "cohortsTitle": "Wellen",
      "cohortsBody": "Jeder Starttag bildet eine Welle. Zahlen sind live.",
      "code": "Code",
      "start": "Start",
      "state": "Status",
      "checkInsToday": "heute",
      "messages": "Nachrichten",
      "noCohorts": "Noch keine Wellen.",
      "coverImage": "Cover-Bild (URL)"
    },
    "questions": {
      "title": "Anonyme Fragen",
      "open": "Offen",
      "answered": "Beantwortet",
      "answer": "Antwort",
      "send": "Antwort senden",
      "overdue": "Überfällig",
      "none": "Keine Fragen in dieser Liste.",
      "session": "Zu Session: {title}",
      "noSession": "Allgemeine Frage",
      "asked": "Gestellt {when}",
      "answeredAt": "Beantwortet {when}",
      "hint": "Wer gefragt hat, siehst du nicht. Die Antwort landet in der App der Person."
    },
    "settings": {
      "title": "Einstellungen",
      "church": "Gemeinde",
      "name": "Name",
      "timezone": "Zeitzone",
      "defaultLocale": "Standardsprache",
      "celebration": "Celebration",
      "celebrationUrl": "YouTube-Link (letzter Gottesdienst)",
      "celebrationTitle": "Titel",
      "celebrationDate": "Datum",
      "links": "Links",
      "teamUrl": "Team-Link (Mitmachen)",
      "donateUrl": "Spenden-Link",
      "churchCenterUrl": "Church-Center-Link",
      "contacts": "Kontakte",
      "crisisContact": "Krisenkontakt",
      "decisionContact": "Entscheidungskontakt",
      "none": "— nicht gesetzt —",
      "staff": "Team",
      "inactive": "wartet auf 2FA",
      "adminsOnly": "Nur Admins können Einstellungen ändern.",
      "preview": "Vorschau",
      "noChurch": "Wähle oben eine Gemeinde, um ihre Einstellungen zu sehen.",
      "calendlyUrl": "Calendly-Link (Gespräche „Jesus nachfolgen“)",
      "legal": "Rechtstexte (Hey Church)",
      "legalApp": "Rechtstexte (Hey-Life-App)",
      "legalAppBody": "Für alle sichtbar unter Me → Tab „App“ (Datenschutz, Impressum, AGB). Nur Superadmin.",
      "legalAppHint": "Gleiche Locale-Regeln wie anderer Content (App-Sprache, dann DE, dann EN). Seite unten antippen zum Bearbeiten.",
      "legalFor": "Gilt für: {church}",
      "legalBody": "Euer Kirchen-Text erscheint unter Me → Tab „Hey Church“. Gleiche Locale-Regeln wie anderer Content (App-Sprache, dann DE, dann EN).",
      "legalLocaleHint": "Deutsch- und Englisch-Felder wie bei Content — Mitglieder sehen die passende App-Sprache.",
      "legalViewOnly": "Rechtstexte können nur von Kirchen-Admins bearbeitet werden.",
      "globalScopeHint": "Globaler Bereich — Hey-Life-App-Rechtstexte unten bearbeiten. Gemeinde in der Seitenleiste wählen für Kirchen-Einstellungen.",
      "legalToolbar": "Formatierung",
      "legalAlignLeft": "Linksbündig",
      "legalAlignCenter": "Zentriert",
      "legalAlignRight": "Rechtsbündig",
      "legalForbiddenSuper": "App-weite Rechtstexte können nur als Superadmin gespeichert werden (z. B. superadmin@demo.heylife.test). Kirchen-Texte bearbeitest du unter „Rechtstexte (Hey Church)“ mit gewählter Gemeinde in der Seitenleiste.",
      "legalPlaceholder": "Rechtstext hier eingeben…",
      "legalPrivacy": "Datenschutz",
      "legalImprint": "Impressum",
      "legalTerms": "AGB",
      "legalEdit": "Bearbeiten",
      "legalEmpty": "Noch kein Text — in der App ausgeblendet.",
      "legalLocaleDe": "Deutsch",
      "legalLocaleEn": "Englisch",
      "legalPreview": "Vorschau",
      "audit": "Protokoll",
      "auditBody": "Jeder Versand, jede Rollen-, Personen-, Vorlagen-, PDF- und Belohnungsänderung — lesbar für Pastor:innen und Admins.",
      "auditExport": "Als Word exportieren",
      "auditEmpty": "Noch keine Einträge.",
      "sentryDevTitle": "Diagnose",
      "sentryDevBody": "Testereignis an Sentry senden (nur Nicht-Produktion).",
      "sentryTestMessage": "Sentry-Testnachricht",
      "sentryTestCrash": "Sentry-Testabsturz",
      "sentryTestSent": "Testereignis an Sentry gesendet. In etwa einer Minute unter Issues (Umgebung: development) prüfen.",
      "auditActor": "Admin",
      "auditAction": "Aktion",
      "auditTarget": "Ziel",
      "auditTime": "Zeit"
    },
    "churches": {
      "title": "Gemeinden",
      "new": "Neue Gemeinde",
      "name": "Name",
      "slug": "Slug",
      "adminEmail": "Admin-E-Mail (optional, erhält Einladung)",
      "create": "Anlegen",
      "status": "Status",
      "members": "Mitglieder",
      "admins": "Admins",
      "pendingInvites": "Offene Einladungen",
      "invite": "Einladen",
      "inviteEmail": "E-Mail",
      "role": "Rolle",
      "goLiveMissing": "Fehlt für Live: {items}",
      "crisis_contact": "Krisenkontakt",
      "decision_contact": "Entscheidungskontakt",
      "invites": "Einladungen",
      "sent": "Einladung verschickt.",
      "created": "Gemeinde angelegt.",
      "statusChanged": "Status geändert.",
      "expires": "läuft ab {when}",
      "accepted": "angenommen",
      "pending": "offen"
    },
    "features": {
      "title": "Feature-Matrix · {church}",
      "hint": "Lege fest, welche Command-Center-Module, Mobile-Navigation und App-Funktionen für diese Gemeinde gelten. Rollen-Defaults bleiben für App-Features aktiv — du kannst Einträge nur für die Gemeinde abschalten. Abgemeldete Gäste nutzen die Gäste-Reiter oben auf dieser Seite.",
      "saved": "Feature-Matrix gespeichert.",
      "guestTabs": {
        "title": "Abgemeldet und Gäste",
        "hint": "Lege fest, welche Reiter abgemeldete Gäste und Konten ohne Gemeinde und ohne Fam in der App sehen.",
        "saved": "Gäste-Reiter gespeichert."
      },
      "adminSection": "Command Center",
      "contentSection": "Content-Reiter",
      "mobileTabsSection": "Mobile App · Reiter",
      "mobileMeSection": "Mobile App · Ich-Menü",
      "me": {
        "credentials": "Zertifikate",
        "points": "Punkte",
        "gym": "Hey Gym",
        "journal": "Journal",
        "prayFor": "Für wen ich bete",
        "fam": "Hey Fam",
        "myTeam": "Mein Team",
        "followJesus": "Jesus folgen",
        "invest": "Investieren",
        "talk": "Mit jemandem reden",
        "care": "Care-View",
        "myChurch": "Meine Kirche"
      },
      "appSections": {
        "onboarding": "Onboarding & Konto",
        "home": "Home",
        "challenges": "Challenges",
        "community": "Community",
        "me": "Ich",
        "leadership": "Leitung & Seelsorge"
      },
      "app": {
        "guestMode": "Gast-Modus",
        "accountCreate": "Konto anlegen",
        "myChurch": "Meine Kirche",
        "languageQuiet": "Sprache & Ruhezeiten",
        "notifications": "Benachrichtigungen",
        "dailyWord": "Daily Word",
        "celebration": "Letzte Celebration",
        "activeQuest": "Aktive Quest",
        "balanceRing": "Balance Ring",
        "oneThingToday": "Heute eine Sache",
        "followUpPrompt": "Follow-up-Prompt",
        "challengesBrowse": "Wellen entdecken",
        "challengeCheckIn": "Check-in",
        "cohortChat": "Kohorten-Chat",
        "challengeShareCard": "Abschluss-Karte",
        "stayTogetherFam": "Zusammenbleiben → Fam",
        "feed": "Feed",
        "prayerWallRead": "Gebetswand lesen",
        "prayerShare": "Anliegen teilen",
        "prayerComments": "Kommentare",
        "famChat": "Fam-Chat",
        "directMessages": "1:1 Nachrichten",
        "famIdeas": "Ideen & Abstimmungen",
        "certificates": "Zertifikate",
        "gym": "Hey Gym",
        "journal": "Journal",
        "heyFam": "Hey Fam",
        "myTeam": "Mein Team",
        "prayFor": "Für wen ich bete",
        "invest": "Investieren",
        "talkSomeone": "Mit jemandem reden",
        "faithCheck": "Faith Check",
        "careView": "Care-View",
        "decisionsTake": "Entscheidungen übernehmen",
        "leadFam": "Fam leiten",
        "commandCenter": "Command Center (App)"
      }
    },
    "activate": {
      "title": "Zugang freischalten",
      "body": "Bestätige, um deinen Zugang zum Command Center zu aktivieren.",
      "start": "Freischalten",
      "scan": "Scanne den QR-Code mit deiner Authenticator-App und gib dann den 6-stelligen Code ein.",
      "manual": "Oder manuell eingeben:",
      "code": "Code",
      "verify": "Bestätigen & freischalten",
      "backupCodes": "Backup-Codes – bitte sicher aufbewahren:",
      "done": "Fertig. Dein Zugang ist aktiv."
    },
    "attention": {
      "title": "Needs Attention",
      "body": "Eine Liste. Jeder Eintrag hat Dringlichkeit, SLA und genau eine Aktion.",
      "empty": "Nichts wartet. Genieß die Ruhe.",
      "refresh": "Neu bewerten",
      "resolve": "Erledigt",
      "overdue": "überfällig",
      "dueIn": "fällig {time}",
      "since": "seit {time}",
      "critical": "Kritisch",
      "high": "Hoch",
      "medium": "Mittel",
      "kind": {
        "crisis_flag": "Krisenhinweis",
        "decision_uncontacted": "Entscheidung ohne Kontakt",
        "unprayed_urgent": "Dringendes Anliegen ohne Gebet",
        "unanswered_question": "Unbeantwortete Frage",
        "moderation_report": "Moderation",
        "care_open": "Seelsorge-Anfrage",
        "role_approval": "Rollenfreigabe",
        "fam_request": "Fam-Anfrage",
        "church_go_live": "Go-live blockiert",
        "reward_request": "Belohnungsanfrage",
        "baptism_call": "Persönlich anrufen",
        "backup_stale": "Backup veraltet"
      },
      "action": {
        "care": "Seelsorge öffnen",
        "questions": "Beantworten",
        "moderation": "Prüfen",
        "people": "Freigeben",
        "fams": "Fams öffnen",
        "prayer": "Gebetswand",
        "churches": "Gemeinde öffnen",
        "rewards": "Belohnungen öffnen",
        "decisions": "Gespräch öffnen",
        "ops": "Statusseite öffnen"
      },
      "takeCare": "Übernehmen",
      "closeCare": "Schließen"
    },
    "moderation": {
      "title": "Moderation",
      "body": "Gemeldete Inhalte aus Chat, Feed, Gebetswand und Check-ins. Für die meldende Person sind sie bereits ausgeblendet.",
      "open": "Offen",
      "decided": "Entschieden",
      "empty": "Keine offenen Meldungen.",
      "reportedBy": "gemeldet von {name}",
      "author": "von {name}",
      "prior": "{count} frühere Meldungen",
      "hide": "Ausblenden",
      "remove": "Entfernen",
      "dismiss": "Abweisen",
      "hideHint": "Ausgeblendet: Autor:in sieht es weiter.",
      "removeHint": "Entfernt: für alle weg.",
      "status": {
        "open": "offen",
        "hidden": "ausgeblendet",
        "removed": "entfernt",
        "dismissed": "abgewiesen"
      },
      "type": {
        "message": "Chat-Nachricht",
        "feed_post": "Feed-Beitrag",
        "prayer_request": "Gebetsanliegen",
        "check_in": "Check-in"
      }
    },
    "prayerWall": {
      "title": "Gebetswand",
      "body": "Alle Anliegen deiner Gemeinde, auch Fam-Anliegen im 2-Stunden-Fenster.",
      "withdraw": "Zurückziehen",
      "withdrawn": "zurückgezogen",
      "answered": "erhört",
      "crisis": "Krisenhinweis",
      "prayers": "{count} gebetet",
      "famWindow": "Nur Fam",
      "empty": "Keine Anliegen."
    },
    "fams": {
      "title": "Fams",
      "body": "Lebendigkeit pro Fam, offene Anfragen und die Planning-Center-Verbindung.",
      "members": "{total} Mitglieder · {inFam} in einer Fam · {requested} angefragt",
      "requests": "Offene Anfragen",
      "requestsEmpty": "Keine offenen Anfragen.",
      "confirm": "Bestätigen",
      "decline": "Ablehnen",
      "matching": "Vermittlungsanfragen",
      "matchingEmpty": "Niemand wartet auf Vermittlung.",
      "place": "In Fam vermitteln",
      "dismiss": "Erledigt",
      "prefs": "Wünsche",
      "list": "Alle Fams",
      "new": "Neue Fam",
      "edit": "Fam bearbeiten",
      "name": "Name",
      "description": "Beschreibung",
      "capacity": "Kapazität",
      "leader": "Leitung (User-ID)",
      "leaderHint": "Aus People & Roles wählen; leer = noch keine Leitung.",
      "meetingDay": "Tag",
      "meetingTime": "Uhrzeit",
      "area": "Stadtteil",
      "churchCenterUrl": "Church-Center-Link",
      "headerImage": "Header-Bild-URL",
      "baptism": "Tauf-Fam",
      "archived": "Archiviert",
      "origin": {
        "pco": "Planning Center",
        "manual": "Manuell",
        "global": "Global"
      },
      "liveness": {
        "green": "lebendig",
        "yellow": "ruhig",
        "red": "still",
        "archived": "archiviert",
        "grey": "noch kein Chat"
      },
      "colMembers": "Mitglieder",
      "colRequests": "Anfragen",
      "colChat": "Chat (7 T.)",
      "colLast": "Letzte Nachricht",
      "colLeader": "Leitung",
      "never": "nie",
      "pcoTitle": "Planning Center Groups",
      "pcoConnected": "Verbunden · letzter Abgleich {when}",
      "pcoNever": "Verbunden · noch nicht abgeglichen",
      "pcoError": "Letzter Abgleich fehlgeschlagen: {error}",
      "pcoNot": "Nicht verbunden — die Fam-Liste wird hier von Hand gepflegt.",
      "pcoAppId": "Application ID",
      "pcoSecret": "Secret",
      "pcoConnect": "Verbinden",
      "pcoDisconnect": "Trennen",
      "pcoSync": "Jetzt abgleichen",
      "pcoSynced": "Abgeglichen: {groups} Gruppen, {created} neu, {confirmed} Anfragen bestätigt.",
      "pcoHint": "Personal Access Token von api.planningcenteronline.com. Nur lesend; verschlüsselt gespeichert. Auf dem Testserver „demo“ als beide Werte eintragen.",
      "pcoReadonly": "Wird in Planning Center gepflegt — Name, Termin und Bild gleichen sich automatisch ab.",
      "noChurch": "Wähle eine Gemeinde, um Fams zu verwalten."
    },
    "pulse": {
      "title": "Puls",
      "body": "Die letzten 7 Tage gegen die 7 davor. Die Zahlen kommen aus der nächtlichen Faktentabelle — nur Zählungen, nie Inhalte.",
      "empty": "Noch keine Fakten. Der Nachtjob füllt die Tabelle nach der ersten Nacht.",
      "wow": "ggü. Vorwoche",
      "chart": "Letzte {days} Tage",
      "latest": "Stand {day}",
      "wau": "Wöchentlich aktiv",
      "members": "Konten",
      "guests": "Gäste",
      "famMembers": "In einer Fam",
      "balanced": "Ausgewogen",
      "balancedHint": "Menschen, die diese Woche in mindestens drei Bereichen aktiv waren.",
      "metric": {
        "dau": "Täglich aktiv (Ø)",
        "new_users": "Neue Menschen",
        "check_ins": "Check-ins",
        "prayers": "Gebete des Tages",
        "prayer_requests": "Gebetsanliegen",
        "messages": "Chat-Nachrichten",
        "sessions_completed": "Sessions abgeschlossen",
        "gym_sessions": "Gym-Einheiten",
        "journal_entries": "Journal-Einträge",
        "fam_requests": "Fam-Anfragen",
        "points_awarded": "Punkte vergeben",
        "notifications_opened": "Pushes geöffnet"
      },
      "series": {
        "dau": "Täglich aktiv",
        "check_ins": "Check-ins",
        "prayers": "Gebete",
        "messages": "Nachrichten",
        "sessions_completed": "Sessions"
      }
    },
    "people": {
      "title": "Personen & Rollen",
      "kicker": "PERSONEN · {n} von {m}",
      "search": "Name, Alias, E-Mail, PLZ, Adresse suchen",
      "allRoles": "Alle Rollen",
      "add": "Person hinzufügen",
      "edit": "Bearbeiten",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "deletePerson": "Person löschen",
      "deleteHint": "Daten werden nach 30 Tagen endgültig entfernt.",
      "deleted": "Löschung vorgemerkt.",
      "filterFam": "In einer Fam",
      "filterTeam": "In einem Team",
      "filterBaptized": "Getauft",
      "filterChildren": "Mit Kindern",
      "col": {
        "fullName": "Voller Name",
        "alias": "Alias",
        "email": "E-Mail",
        "phone": "Telefon",
        "sex": "Geschlecht",
        "birthday": "Geburtstag → Alter",
        "address": "Adresse",
        "postcode": "PLZ",
        "fam": "Fam",
        "team": "Team",
        "baptism": "Taufe",
        "marital": "Familienstand",
        "children": "Kinder",
        "childrenAges": "Alter der Kinder",
        "role": "Rolle",
        "points": "Punkte"
      },
      "years": "{n} J.",
      "months": "{n} Mon.",
      "yes": "Ja",
      "no": "Nein",
      "childrenYes": "Ja · {n}",
      "unknown": "—",
      "marital": {
        "single": "ledig",
        "married": "verheiratet",
        "divorced": "geschieden"
      },
      "role": {
        "member": "Mitglied",
        "leader": "Leiter:in",
        "pastor": "Pastor:in",
        "admin": "Admin"
      },
      "approvals": "Vier-Augen-Freigaben",
      "approvalsEmpty": "Nichts freizugeben.",
      "approvalRow": "{name} → {role} · vorgeschlagen von {by}",
      "approve": "Freigeben",
      "reject": "Ablehnen",
      "ownProposal": "Dein eigener Vorschlag — eine Kollegin gibt frei.",
      "pending": "Freigabe ausstehend",
      "proposed": "Vorgeschlagen — ein zweiter Admin gibt frei.",
      "roleChanged": "Rolle geändert.",
      "childrenBirthdays": "Geburtsdaten der Kinder",
      "addChild": "Kind hinzufügen",
      "remove": "Entfernen",
      "required": "Voller Name und E-Mail sind Pflicht.",
      "adminsOnly": "Nur Admins ändern Rollen und legen Personen an oder löschen sie.",
      "empty": "Niemand passt.",
      "fullNamePrivacy": "Voller Name und Adresse sehen nur Pastor:innen und Admins; die App zeigt den Alias.",
      "message": "Nachricht",
      "created": "Person angelegt.",
      "saved": "Gespeichert."
    },
    "notifications": {
      "title": "Benachrichtigungen",
      "body": "Eine Nachricht als Push, E-Mail oder beides senden. Admins einer Gemeinde bleiben in ihrer Gemeinde. Superadmins wählen die Empfänger.",
      "send": "Nachricht senden",
      "templates": "Vorlagen",
      "newTemplate": "Neue Vorlage",
      "filter": "Vorlagen filtern",
      "audience": "Zielgruppe",
      "medium": "Medium",
      "reachChurch": "Diese Gemeinde",
      "reachEveryone": "Alle Gemeinden",
      "reachPerson": "Eine Person",
      "pickChurch": "Gemeinde wählen",
      "personSearch": "Name oder E-Mail",
      "to": "An {name}",
      "titleLabel": "Titel",
      "textLabel": "Text",
      "localizedRequired": "Bitte Titel und Text auf Deutsch und/oder Englisch eingeben.",
      "preview": {
        "push": "Push-Vorschau",
        "email": "E-Mail-Vorschau",
        "both": "Push und E-Mail"
      },
      "sendTo": "An {n} senden",
      "sendOne": "Senden",
      "testToMe": "Testnachricht an mich",
      "testSent": "Testnachricht eingereiht ({status}).",
      "sent": "An {n} gesendet.",
      "scheduled": "Geplant.",
      "schedule": "Zeitpunkt (optional)",
      "usingTemplate": "Vorlage „{name}“ übernommen — alles bleibt editierbar.",
      "placeholders": "Platzhalter: {FirstName} {Fam} {Challenge} {Team} {VIP}",
      "name": "Name",
      "dimension": "Dimension",
      "category": "Kategorie",
      "audienceDefault": "Standard-Zielgruppe",
      "buttons": "Buttons in der Nachricht",
      "buttonLabel": "Beschriftung",
      "buttonRoute": "Route",
      "addButton": "Button hinzufügen",
      "system": "System",
      "custom": "Eigene",
      "deleteTemplate": "Vorlage löschen",
      "sendWith": "Mit dieser Vorlage senden",
      "log": "Gesendet",
      "logEmpty": "Noch nichts gesendet.",
      "today": "Heute: {sent} gesendet · {queued} eingereiht · {skipped} übersprungen · {opened} geöffnet",
      "recipients": "{n} Empfänger:innen",
      "scheduledFor": "geplant {date}",
      "by": "von {name}",
      "close": "Schließen",
      "aud": {
        "all": "Alle",
        "guest": "Gast",
        "global": "Global",
        "hey_church": "Hey Church",
        "leader": "Leiter:in",
        "pastor_admin": "Pastor/Admin",
        "user": "Person"
      },
      "via": {
        "push": "Push",
        "email": "E-Mail",
        "both": "Push und E-Mail"
      },
      "cat": {
        "rhythm": "Rhythmus",
        "fam_cohort": "Fam & Challenge",
        "progress": "Fortschritt",
        "personal": "Persönlich",
        "staff": "Team"
      },
      "tabTemplates": "Vorlagen",
      "tabMatrix": "Benachrichtigungs-Matrix",
      "tabOthers": "Sonstiges",
      "automatic": {
        "title": "Automatische Benachrichtigungen",
        "hint": "Wähle E-Mail, Push und Abgemeldet für jede automatische Aktion in dieser Gemeinde. Feste Zeilen bleiben nur E-Mail. Abgemeldet wird nur gespeichert — Zustellung folgt später.",
        "saved": "Einstellungen für automatische Benachrichtigungen gespeichert.",
        "fixedEmail": "Fest — nur E-Mail",
        "inAppDefault": "Standard in der App",
        "othersTitle": "Sonstiges — Eigene Benachrichtigungen",
        "othersHint": "Ankündigungen erstellen, die nicht in der vordefinierten Liste automatischer Benachrichtigungen stehen.",
        "othersCreate": "+ Eigene Benachrichtigung erstellen",
        "othersCreateTitle": "Eigene Benachrichtigung erstellen",
        "othersCreateHint": "Für einmalige Hinweise — z. B. ausgefallenes Gebet oder neuer Ort. Mit Feed-Option erscheint der Beitrag in Community; optional Push oder E-Mail. Gäste dieser Gemeinde erhalten die Benachrichtigung ebenfalls.",
        "othersPublishFeed": "Im Community-Feed veröffentlichen",
        "othersFeedPublished": "Im Community-Feed veröffentlicht",
        "othersAudience": "{n, plural, =0 {Geht an Hey-Church-Mitglieder dieser Gemeinde (noch keine Empfänger).} one {Geht an Hey-Church-Mitglieder dieser Gemeinde (# Person).} other {Geht an Hey-Church-Mitglieder dieser Gemeinde (# Personen).}}",
        "othersSend": "Ankündigung veröffentlichen",
        "othersCreated": "Ankündigung veröffentlicht.",
        "othersSoon": "Kommt in einer späteren Version",
        "columns": {
          "action": "Automatische Aktion",
          "email": "E-Mail",
          "push": "Push",
          "loggedOut": "Abgemeldet"
        }
      },
      "groups": {
        "home": "Home",
        "grow": "Grow",
        "challenges": "Challenges",
        "community": "Community",
        "me": "Ich",
        "signIn": "Anmelden",
        "commandCenter": "Command Center"
      },
      "subsections": {
        "session": "Session",
        "myQuestions": "Meine Fragen",
        "cohort": "Cohort",
        "cohortChat": "Cohort-Chat",
        "prayer": "Gebet",
        "fam": "Fam",
        "talkRequest": "Gesprächswunsch",
        "followJesus": "Jesus folgen",
        "myTeam": "Mein Team",
        "points": "Punkte",
        "credentials": "Zertifikate",
        "gym": "Hey Gym",
        "settings": "Einstellungen",
        "care": "Care",
        "today": "Heute",
        "questions": "Fragen",
        "fams": "Fams",
        "people": "Menschen",
        "rewards": "Belohnungen"
      },
      "actions": {
        "home_dailyWord": "Daily Word um 08:00 (entfällt, wenn die App heute schon geöffnet wurde)",
        "home_growSheet": "Grow-Sheet einmal pro Kaltstart, wenn Fragen noch offen sind",
        "home_celebrationReminder": "Erinnerung an den Celebration-Gottesdienst (z. B. Sonntagmorgen)",
        "home_activeQuestReminder": "Aktive Quest noch in Arbeit — sanfter Hinweis",
        "grow_quizContinue": "15 Minuten nach der letzten Antwort — Quiz fortsetzen (einmal pro Session)",
        "grow_session_questionsWaiting": "Deine Fragen warten (In-App-Hinweis)",
        "grow_session_videoIncomplete": "Session-Video begonnen, aber nicht beendet",
        "grow_session_reflectionDue": "Session-Reflexion noch nicht abgeschickt",
        "grow_myQuestions_answered": "Deine anonyme Frage wurde beantwortet",
        "challenges_cohort_checkInOpen": "19:00 — heutiger Check-in noch offen",
        "challenges_cohort_completedShare": "Challenge abgeschlossen — Share-Karte bereit (wenn nicht in der App)",
        "challenges_cohort_stayTogetherFam": "Mittwoch — als Fam zusammenbleiben? (nach Cohort-Ende)",
        "challenges_cohort_invitePending": "Einladung zur Challenge-Cohort wartet auf deine Antwort",
        "challenges_cohort_checkInMissed": "Gesternigen Cohort-Check-in verpasst",
        "challenges_cohortChat_newMessages": "Neue Nachrichten im Cohort-Chat (gebündelt, Tageslimit)",
        "community_prayer_newRequest": "Neues Gebetsanliegen für deine Fam",
        "community_prayer_prayedForYou": "Jemand hat für dein Anliegen gebetet (einmal pro Tag)",
        "community_prayer_markedAnswered": "Dein Gebetsanliegen wurde an der Wall als beantwortet markiert",
        "community_fam_placement": "Fam-Anfrage bestätigt oder Gemeinde hat dich einer Fam zugewiesen",
        "community_fam_newMessages": "Neue Nachrichten im Fam-Chat (gebündelt, Tageslimit)",
        "community_fam_newMember": "Jemand Neues ist deiner Hey Fam beigetreten",
        "me_talkRequest_pastorAssigned": "Jemand meldet sich — Pastor hat deinen Gesprächswunsch übernommen",
        "me_talkRequest_received": "Wir haben deinen Gesprächswunsch erhalten (Bestätigung)",
        "me_talkRequest_followUp48h": "Update zum Gesprächswunsch, wenn nach 48 Stunden niemand sich meldet",
        "me_followJesus_youSaidYes": "Du hast Ja gesagt (einmal)",
        "me_followJesus_bookSlot": "Zwei Tage später — Termin buchen",
        "me_followJesus_baptismFam": "Taufe-Fam-Einladung und Erinnerungen",
        "me_followJesus_conversationPdf": "Gesprächs-PDF, wenn ein Admin es sendet",
        "me_myTeam_checkInCard": "Vier-Wochen-Check-in-Karte",
        "me_myTeam_checkInReminder": "Check-in Tag 28 und 56, wenn Karte nicht beantwortet",
        "me_myTeam_leaderAssigned": "Dein My-Team-Link oder Leader wurde zugewiesen",
        "me_points_rewardReady": "Belohnung einlösbar (einmal pro Belohnung)",
        "me_points_rewardUpdate": "Leader hat Datum gesetzt oder Belohnung wurde gesendet",
        "me_points_streakMilestone": "Punkte-Meilenstein erreicht (vor Belohnungs-Freischaltung)",
        "me_points_thirtyDaysWithGod": "30 Tage mit Gott (innerhalb von fünf Minuten, erneut sendbar)",
        "me_credentials_certificateReady": "Grow- oder Hey-Gym-Zertifikat bereit (wenn nicht auf dem Bildschirm)",
        "me_gym_planReminder": "Nächster Abend — dein Gym-Plan ist einen Schritt entfernt",
        "me_gym_weeklyProgress": "Wöchentlicher Hey-Gym-Fortschrittshinweis",
        "me_settings_deletionConfirm": "Löschbestätigung mit Datum und Abbruchhinweis",
        "me_care_crisis": "Krisenformulierung — sofort (ignoriert Ruhezeit und Limit)",
        "me_care_sameDayCare": "Am selben Tag — Gesprächswunsch, dringendes Gebet, jemand hat Ja gesagt",
        "me_care_pastorEmailFallback": "Dieselben drei, wenn Pastor keinen Push-Token hat",
        "me_journal_eveningPrompt": "Abendlicher Journal-Hinweis (In-App)",
        "signIn_magicLink": "Magic Link",
        "commandCenter_today_weeklyDigest": "Montag 07:00 — Wochenzahlen und Needs Attention",
        "commandCenter_questions_open48h": "Einmal täglich — anonyme Fragen offen nach 48 Stunden",
        "commandCenter_fams_joinOrMatch": "Jemand möchte einer Fam beitreten oder gematcht werden",
        "commandCenter_people_fourEyesApproval": "Vier-Augen-Rollenfreigabe ausstehend",
        "commandCenter_people_adminInvite": "Admin-Einladung und Rollenzuweisung",
        "commandCenter_rewards_redeemLeader": "Belohnungseinlösung braucht einen Leader"
      }
    },
    "rewards": {
      "title": "Punkte & Belohnungen",
      "body": "Punktwerte gelten sofort für neue Aktionen; alte Einträge behalten ihre. Belohnungen sind Meilensteine mit Schwelle.",
      "points": "Punktwerte",
      "action": "Aktion",
      "defaultValue": "Standard",
      "value": "Wert ({scope})",
      "dailyLimit": "Tageslimit",
      "unlimited": "unbegrenzt",
      "override": "Gemeinde-Override",
      "global": "Globale Standards",
      "saveConfig": "Werte speichern",
      "saved": "Gespeichert.",
      "rewardsList": "Belohnungen",
      "newReward": "Neue Belohnung",
      "editReward": "Belohnung bearbeiten",
      "threshold": "Schwelle",
      "kind": "Typ",
      "leaders": "Leiter:innen (eine pro Zeile)",
      "fileUrl": "Datei-Link (digitales Buch)",
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "requests": "Einlösungen",
      "requestsEmpty": "Noch keine Einlösungen.",
      "dateSet": "„Termin steht“ setzen",
      "markSent": "Als gesendet markieren",
      "resend": "E-Mail erneut senden",
      "status": {
        "redeemable": "einlösbar",
        "requested": "angefragt",
        "date_set": "Termin steht",
        "sent": "gesendet"
      },
      "kinds": {
        "physical": "Physisch",
        "digital_book": "Digitales Buch",
        "leader_meet": "Treffen mit Leiter:in"
      },
      "prefers": "wünscht {leader}",
      "noPhone": "keine Nummer",
      "call": "Anrufen",
      "actions": {
        "prayer_of_day": "Gebet des Tages",
        "prayer_request": "Gebetsanliegen",
        "intercession": "Fürbitte (Karte geteilt)",
        "prayed_for": "Für ein Anliegen gebetet",
        "invitation": "Einladung (Registrierung)",
        "challenge_day": "Challenge · pro Tag",
        "challenge_complete": "Challenge · Abschluss",
        "session_engaged": "Grow · pro Session",
        "path_certificate": "Grow · Zertifikat",
        "gym_session": "Hey Gym · pro Einheit",
        "gym_plan_complete": "Hey Gym · Plan abgeschlossen",
        "one_thing": "Eine Sache heute",
        "journal_entry": "Tagebucheintrag",
        "feed_post": "Feed-Beitrag",
        "check_in": "Check-in"
      }
    },
    "team": {
      "title": "Andere stärken",
      "body": "Wer sich die Teams angeschaut hat, was geantwortet wurde, wer Nachfassen braucht.",
      "filter": {
        "all": "Alle",
        "trying": "Probiert aus",
        "arrived": "Angekommen",
        "no_contact": "Noch kein Kontakt",
        "not_interested": "Kein Interesse",
        "none": "Noch keine Antwort"
      },
      "col": {
        "name": "Name",
        "clicked": "Link geklickt",
        "answer": "Antwort",
        "next": "Nächster Check-in",
        "actions": "Aktionen"
      },
      "ask": "Nachfragen",
      "asked": "Check-in gepusht.",
      "message": "Nachricht",
      "empty": "Gerade ist niemand an diesem Punkt.",
      "followUp": "Nachfassen",
      "followUpBody": "Keine Antwort 4 Wochen nach dem Check-in oder „gerade kein Interesse“.",
      "reasonNoAnswer": "Keine Antwort · Check-in vor {n} Tagen",
      "reasonNotInterested": "Kein Interesse · {choice}",
      "choice": {
        "have_team": "hat schon ein Team",
        "unsure": "unsicher, welches Team passt",
        "none": "kein Grund angegeben"
      },
      "due": "fällig",
      "noUrl": "Lege zuerst den Team-Link unter Einstellungen fest.",
      "kpiClicked": "Teams angeschaut",
      "kpiArrived": "Im Team angekommen",
      "kpiFollowUp": "Brauchen Nachfassen"
    },
    "decisions": {
      "title": "Jesus nachfolgen · Gespräche",
      "body": "Alle, die Ja gesagt haben: Telefon, Termin, Status, Notizen und Ampel. Notizen erreichen die App nie.",
      "col": {
        "name": "Name",
        "phone": "Telefon",
        "slot": "Termin",
        "status": "Status",
        "light": "Ampel",
        "baptism": "Tauf-Hey-Fam"
      },
      "call": "Anrufen",
      "open": "offen",
      "held": "geführt",
      "light": {
        "none": "nicht gesetzt",
        "green": "grün · zur Tauf-Hey-Fam einladen",
        "yellow": "gelb · braucht etwas anderes",
        "grey": "grau · gerade kein Thema"
      },
      "notes": "Notizen (nur Pastor:in/Admin)",
      "saveNotes": "Notizen speichern",
      "saved": "Gespeichert.",
      "slotManual": "Termin (manuell)",
      "viaCalendly": "über Calendly",
      "noSlot": "noch kein Termin",
      "sendPdf": "PDF senden",
      "pdfSent": "PDF gesendet",
      "pdfMeta": "{email} (Calendly)",
      "pdfNoEmail": "keine E-Mail von Calendly",
      "pdfNeedsHeld": "verfügbar, sobald das Gespräch geführt ist",
      "pdfCard": "PDF nach dem Gespräch",
      "pdfUpload": "Anderes PDF hochladen",
      "pdfNone": "Noch kein PDF.",
      "pdfInfo": "{date} · {size} · {pages} Seiten",
      "pdfTooBig": "Das PDF darf höchstens 10 MB groß sein.",
      "pdfUploaded": "PDF für alle künftigen Sendungen ersetzt.",
      "baptismInvited": "eingeladen {date}",
      "baptismReminders": "{n} Erinnerungen",
      "baptismSignedUp": "angemeldet {date}",
      "callTask": "Persönlich anrufen",
      "callDone": "Angerufen",
      "empty": "Noch niemand hat Ja gesagt.",
      "yesMail": "„Du hast Ja gesagt“-Mail gesendet",
      "noCalendly": "Hinterlege den Calendly-Link unter Einstellungen, damit Personen buchen können."
    },
    "theme": {
      "dark": "Dunkles Design",
      "light": "Helles Design"
    }
  },
  "card": {
    "prayerFor": "Gebet für {name}",
    "pathCertificate": "Zertifikat · Grow",
    "gymCertificate": "Zertifikat · Hey Gym",
    "completedBy": "Hiermit wird bestätigt, dass",
    "completedWhat": "abgeschlossen hat:",
    "challengeDone": "Challenge geschafft",
    "checkIns": "{count} von {total} Check-ins",
    "joinMe": "Mach mit – der Link startet dich an meinem Tag:"
  },
  "push": {
    "dailyWordTitle": "Dein Wort für heute",
    "dailyWordBody": "{ref} — eine Minute für dich.",
    "checkinTitle": "Noch offen: dein Check-in heute",
    "checkinBody": "{title} · Tag {day}. Tippe, um einzuchecken.",
    "careNewTitle": "Jemand möchte reden",
    "careNewBody": "Eine neue Anfrage wartet in Care.",
    "careTakenTitle": "Jemand meldet sich",
    "careTakenBody": "Jemand aus dem Pastoralteam hat deine Anfrage übernommen.",
    "challengeDoneTitle": "Challenge abgeschlossen",
    "challengeDoneBody": "{title} — deine Karte ist bereit zum Teilen.",
    "crisisTitle": "Dringend: eine Nachricht braucht deine Aufmerksamkeit",
    "crisisBody": "Krisenwortlaut erkannt. Öffne jetzt Care.",
    "urgentTitle": "Dringendes Gebetsanliegen",
    "famRequestTitle": "Neues Gebetsanliegen in deiner Fam",
    "prayedTitle": "Jemand hat für dich gebetet",
    "prayedBody": "{count, plural, one {# Person hat} other {# Personen haben}} für dein Anliegen gebetet.",
    "certificateTitle": "Zertifikat erhalten",
    "certificateBody": "{title} liegt in deinen Credentials.",
    "famRequestedTitle": "Neue Fam-Anfrage",
    "famRequestedBody": "{alias} möchte zu {fam}.",
    "matchTitle": "Jemand möchte vermittelt werden",
    "matchBody": "{alias} sucht eine Hey Fam.",
    "famConfirmedTitle": "Du bist dabei",
    "famConfirmedBody": "Willkommen bei {fam}. Der Fam-Chat ist jetzt für dich offen.",
    "matchedBody": "Deine Gemeinde hat dich in {fam} vermittelt. Sag Hallo im Chat.",
    "rewardTitle": "Eine Belohnung wartet",
    "rewardBody": "Du hast {reward} erreicht. Löse sie im Ich-Tab ein.",
    "rewardRequestTitle": "Belohnung angefragt",
    "rewardRequestBody": "{alias} möchte {reward} einlösen.",
    "rewardDateTitle": "Termin steht",
    "rewardDateBody": "{leader} meldet sich wegen {reward} bei dir.",
    "rewardSentTitle": "Unterwegs",
    "rewardSentBody": "Deine Belohnung {reward} ist unterwegs.",
    "decisionTitle": "Jemand hat Ja gesagt",
    "decisionBody": "{alias} möchte Jesus nachfolgen. Melde dich.",
    "bookTalkTitle": "Lass uns reden",
    "bookTalkBody": "Du hast Ja gesagt — buch einen Termin oder lass dich anrufen.",
    "baptismInviteTitle": "Tauf-Hey-Fam",
    "baptismInviteBody": "Du bist zur Tauf-Hey-Fam eingeladen. Melde dich diese Woche an.",
    "baptismRemindTitle": "Schon angemeldet?",
    "baptismRemindBody": "Hast du dich schon für die Tauf-Hey-Fam angemeldet? Tippe zum Antworten.",
    "teamCheckinTitle": "Vier Wochen später",
    "teamCheckinBody": "Du hast dir die Teams angeschaut. Wo stehst du jetzt?",
    "approvalTitle": "Rollenfreigabe nötig",
    "approvalBody": "Eine Kollegin hat die Rolle {role} vorgeschlagen. Vier Augen, bitte.",
    "quizContinueTitle": "Mach mit deinem Quiz weiter",
    "quizContinueBody": "{title} hat noch offene Fragen."
  }
}
